import { DataLayerEventName } from '../helpers/DataLayerEventName'
import { SSWTransaction } from '../ssw'
import { ComponentEvent } from './component-event'

export interface SubscribeEventProps {
    /* What paywall method was implemented ie freemium vs metered */
    paywallType: 'freemium'
    /* lead in depth - how many paragraphs were shown in the lead in */
    leadDepth: number
    /* creative name */
    creative: undefined
    breachScreenType: undefined
    popupMethod: undefined
    deal: undefined
    upcomingNotify?: number
    /* Subscription price point */
    pricepoint: number[]
}

type SubscribeCompleteEventProps = SubscribeEventProps & SSWTransaction

export interface SubscribeClickEvent
    extends ComponentEvent<SubscribeEventProps> {
    type: DataLayerEventName.subscribeClick
}

export interface SubscribeCompleteEvent
    extends ComponentEvent<SubscribeCompleteEventProps> {
    type: DataLayerEventName.subscribeComplete
}

interface Transaction {
    sku: string
    name: string
    price: number
    quantity: 1
}

interface SubscribeBaseGTMProps
    extends Omit<SubscribeEventProps, 'pricepoint'> {
    transactionAffiliation: 'The West'
    pricepoint: string
}

interface SubscribeCompleteGTMProps
    extends SubscribeBaseGTMProps,
        Omit<SSWTransaction, 'productSku' | 'productName'> {
    transactionProducts: Transaction[]
    transactionShipping: 0
    transactionAffiliation: 'The West'
    pricepoint: string
}

export type SubscribeEvent = SubscribeClickEvent | SubscribeCompleteEvent

export function toSubscribeBaseEventShape(
    props: SubscribeEventProps,
): SubscribeBaseGTMProps {
    return {
        ...props,
        transactionAffiliation: 'The West',
        pricepoint: props.pricepoint.join(','),
    }
}

export function toSubscribeCompleteEventShape(
    props: SubscribeCompleteEventProps,
): SubscribeCompleteGTMProps {
    const {
        transactionId,
        transactionTotal,
        transactionTax,
        productSku,
        productName,
        pricepoint,
        ...subscribeProps
    } = props

    return {
        ...subscribeProps,
        transactionId,
        pricepoint: pricepoint.join(','),
        transactionAffiliation: 'The West',
        transactionTotal,
        transactionTax,
        transactionShipping: 0,
        transactionProducts: [
            {
                sku: productSku,
                name: productName,
                price: transactionTotal,
                quantity: 1,
            },
        ],
    }
}
